<template>
  <div>
    <div class="container-fluid mx-auto px-0">
      <slot />
    </div>
    <!-- <footer class="footer footer-alt">
        &copy; {{ $t('copyright') }}, {{ currentYear }}, {{ getCompanyInfo && getCompanyInfo.company_name ? getCompanyInfo.company_name : ''}} {{ getCompanyInfo && getCompanyInfo.git_version ? ' | ' + getCompanyInfo.git_version : ''}}
    </footer> -->
  </div>
  </template>
<script>
export default {
  components: {},
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    getCompanyInfo: function () {
      let cInfo = this.$store.state.appAuth.companyInfo || null
      // if (cInfo && cInfo.primary_color){
      //   document.body.style.backgroundColor = cInfo.primary_color;
      // }
      return cInfo
    }
  },
  created: () => {
    document.body.classList.add('authentication-bg');
    document.body.classList.add('authentication-bg-pattern');
  }
}
</script>
